export const knownDomains = {
    linkedin: 'linkedin.com/in',
    x: 'x.com',
    facebook: 'facebook.com',
    instagram: 'instagram.com',
};